import {
    GET_OFFER_OPTIONS,
    OFFER_OPTION_ERROR,
    ADD_OFFER_OPTION,
    DELETE_OFFER_OPTION,
    GET_OFFER_OPTION,
    UPDATE_OFFER_OPTION
} from "../../actions/types";

const initalizeState = {
    offerOptions: [],
    loading: true,
    error: {}
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_OFFER_OPTIONS:
            return {
                ...state,
                offerOptions: payload.offerOptions,
                loading: false
            };
        case ADD_OFFER_OPTION:
            return {
                ...state,
                offerOptions: [payload.offerOption, ...state.offerOptions],
                loading: false
            };
        case DELETE_OFFER_OPTION:
            return {
                ...state,
                offerOptions: state.offerOptions.filter(
                    offerOption => offerOption.id !== payload
                ),
                loading: false
            };
        case UPDATE_OFFER_OPTION:
            let offerOptions = state.offerOptions;
            offerOptions = offerOptions.filter(offerOption => {
                return offerOption.id !== payload.offerOption.id;
            });
            return {
                ...state,
                offerOptions: [payload.offerOption, ...offerOptions],
                loading: false
            };
        case GET_OFFER_OPTION:
            return {
                ...state,
                loading: false
            };
        case OFFER_OPTION_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
